<div class="trip-detail-popup">
  <p>Trip Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Truck Category :</div>
      <div class="result">
        {{ modeldata.truck_category[0].truck_category_name }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Weight :</div>
      <div class="result">{{ modeldata.truck_type[0].truck_weight }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Load Category :</div>
      <div class="result">{{ modeldata.material_type }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Pickup Date :</div>
      <div class="result">
        {{ modeldata.pickup_date | date : "dd-MM-yyyy" }}
      </div>
    </div>
  </div>

  <div class="places">
    <!-- Pickup -->
    <div class="place-row">
      <mat-icon>near_me</mat-icon>
      <div class="place-text">
        <h4>{{ modeldata.pickup_details.from_city_name }}</h4>
        {{ modeldata.from_complete_address }}
        <div class="result">
          Contact Details: {{ modeldata.pickup_name }} - {{ modeldata.pickup_contact }}
        </div>
      </div>
    </div>
    <!-- Stops -->
    <div class="place-row" *ngFor="let stop of modeldata.stops; let i = index">
      <mat-icon>stop_circle</mat-icon>
      <div class="place-text">
        <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
        <div>{{ stop.complete_address }}</div>
        <div class="result">Contact Details: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}</div>
      </div>
    </div>

    <!-- Dropoff -->
    <div class="place-row">
      <mat-icon>location_on</mat-icon>
      <div class="place-text">
        <h4>{{ modeldata.dropoff_details?.to_city_name }}</h4>
        <div>{{ modeldata.to_complete_address }}</div>
        <div class="result">Contact Details: {{ modeldata.dropoff_name }} - {{ modeldata.dropoff_contact }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="head">Pickup Details :</div>
      <div class="result">
        {{ modeldata.from_complete_address }}
      </div>
    </div>
    <div class="col-sm-6">
      <div class="head">Drop Off Details :</div>
      <div class="result">
        {{ modeldata.to_complete_address }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Pickup Contact :</div>
      <div class="result">{{ modeldata.pickup_name }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Pickup Contact Number :</div>
      <div class="result">{{ modeldata.pickup_contact }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Drop Off Contact :</div>
      <div class="result">{{ modeldata.dropoff_name }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Drop Off Contact Number :</div>
      <div class="result">{{ modeldata.dropoff_contact }}</div>
    </div>
  </div>

  <!-- LR Details  -->
  <p>Lorry Receipts(LRs)</p>
  <mat-divider></mat-divider>
  <div class="lr-container mb-4">
    <div class="lr-card-wrapper">
      <!-- Dynamic LR Cards -->
      <div class="lr-card" *ngFor="let lr of modeldata?.elr_details; let i = index">
        <div class="lr-left">
          <div class="lr-title">
            LR No.: {{ lr?.elr_no }}
          </div>

          <div class="lr-sub">
            eway Bill No.: {{ lr.eway_bill_no || '-' }}
          </div>

          <span class="status" [ngClass]="lr.consignor_name || lr.material_name ? 'updated' : 'generated'">
            {{ lr.consignor_name || lr.consignee_name ? 'Updated' : 'Generated' }}
          </span>
        </div>

        <div class="lr-actions">
          <mat-icon *ngIf="
              modeldata?.trip_status === 'tripbooked' ||
              modeldata?.trip_status === 'tripstarted'
            " class="icon edit" (click)="onEdit(modeldata, i)">edit</mat-icon>

          <mat-icon class="icon download" *ngIf="downloadingLRIndex !== i" (click)="DownloadLR(modeldata, i)">
            download
          </mat-icon>

          <mat-progress-spinner *ngIf="downloadingLRIndex === i" diameter="22" mode="indeterminate"
            class="download-spinner">
          </mat-progress-spinner>
        </div>
      </div>
    </div>

    <!-- Generate Button -->
    <button *ngIf="
        modeldata?.trip_status === 'tripbooked' ||
        modeldata?.trip_status === 'tripstarted'
      " class="generate-lr-btn" [disabled]="isGeneratingELR" (click)="generateELR(modeldata)">
      <span>
        {{ isGeneratingELR ? 'Generating…' : 'Generate eLR' }}
      </span>
    </button>
  </div>

  <p>Transporter Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Contact Name :</div>
      <div class="result">{{ modeldata.truckowner_info[0]?.username }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Contact Number :</div>
      <div class="result">{{ modeldata.truckowner_info[0]?.mobile }}</div>
    </div>
  </div>

  <!-- Truck Details  -->
  <p>Truck Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Registration No :</div>
      <div class="result">{{ modeldata.truck_info[0]?.truck_number }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Truck Type :</div>
      <div class="result">
        {{ modeldata.truck_category[0]?.truck_category_name }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Truck Weight :</div>
      <div class="result">{{ modeldata.truck_type[0]?.truck_weight }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Truck Id :</div>
      <div class="result">{{ modeldata.truck_info[0]?.truck_id }}</div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Driver Name :</div>
      <div class="result">{{ modeldata.driver_info[0]?.username }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Driver Number :</div>
      <div class="result">{{ modeldata.driver_info[0]?.mobile }}</div>
    </div>
    <div class="col-sm-6">
      <div class="head">Driver Id :</div>
      <div class="result">{{ modeldata.driver_info[0]?.driver_id }}</div>
    </div>
  </div>
  <p>Price Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-4">
      <div class="head">Total price :</div>
      <div class="result">
        ₹
        {{
        (modeldata.payment_details[0]?.price_details.total_amount).toFixed(2)
        }}
      </div>
    </div>
    <div class="col-sm-4">
      <div class="head">Paid Amount :</div>
      <div class="result">
        ₹
        {{
        (
        modeldata.payment_details[0]?.price_details.payment_history[1]
        ?.amount_paid +
        modeldata.payment_details[0]?.price_details.payment_history[2]
        ?.amount_paid
        ).toFixed(2)
        }}
      </div>
    </div>
    <div class="col-sm-4">
      <div class="head">Balance Amount :</div>
      <div class="result">
        ₹
        {{
        (
        modeldata.payment_details[0]?.price_details.total_amount -
        (modeldata.payment_details[0]?.price_details.payment_history[1]
        ?.amount_paid +
        modeldata.payment_details[0]?.price_details.payment_history[2]
        ?.amount_paid)
        ).toFixed(2)
        }}
      </div>
    </div>
  </div>
  <p>Payment Details</p>
  <mat-divider></mat-divider>
  <div *ngIf="corporatePaymnents">
    <form *ngFor="let item of filteredPaymentArray; let i = index">
      <div class="row" *ngIf="i != 0">
        <div class="head">{{ i }} Payment Details</div>
        <div class="col-sm-4">
          <div class="head">Payment Status :</div>
          <div class="result">
            {{ item.razor_payment_response?.paymentStatus || "N/A" }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Amount :</div>
          <div class="result">₹ {{ item.amount_paid.toFixed(2) }}</div>
        </div>
        <div class="col-sm-4">
          <div class="head">Pay Mode :</div>
          <div class="result">Online</div>
        </div>
      </div>
      <div class="row" *ngIf="i != 0">
        <div class="col-sm-4">
          <div class="head">Pay Date :</div>
          <div class="result">
            {{ item.amount_paid_date | date : "dd-MM-yyyy" }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Transaction ID:</div>
          <div class="result">
            {{ item.razor_payment_response?.success?.order_id || "N/A" }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Comment:</div>
          <div class="result">{{ item.payment_comment || "No Comment" }}</div>
        </div>
      </div>
    </form>
  </div>

  <form *ngFor="let item of paymentArray; let i = index">
    <div class="row" *ngIf="i != 0">
      <div class="head">{{ i }} Payment Details</div>
      <div class="col-sm-4">
        <div class="head">Payment Status :</div>
        <div class="result">
          {{ item.razor_payment_response?.paymentStatus }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head">Amount :</div>
        <div class="result">₹ {{ item.amount_paid.toFixed(2) }}</div>
      </div>
      <div class="col-sm-4">
        <div class="head">Pay Mode :</div>
        <div class="result">Online</div>
      </div>
    </div>
    <div class="row" *ngIf="i != 0">
      <div class="col-sm-4">
        <div class="head">Pay Date :</div>
        <div class="result">
          {{ item.amount_paid_date | date : "dd-MM-yyyy" }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head">Transaction ID:</div>
        <div class="result">
          {{ item.razor_payment_response?.success?.order_id }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head">Comment:</div>
        <div class="result">{{ item.payment_comment }}</div>
      </div>
    </div>
  </form>
  <div class="refund-details" *ngIf="
      modeldata.payment_details[0]?.payment_status == 'refunded' &&
      modeldata.trip_status == 'cancelled'
    ">
    <form>
      <p>Refund Details</p>
      <mat-divider></mat-divider>
      <div class="row">
        <div class="col-sm-4">
          <div class="head">Payment Id :</div>
          <div class="result">
            {{
            modeldata.payment_details[0].price_details.payment_history[1]
            ?.razor_payment_response?.success?.razorpay_payment_id
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Refunded Amount :</div>
          <div class="result">
            ₹
            {{
            modeldata.payment_details[0]?.cancelled_trip_payment_info
            ?.amount_paid
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Refunded Mode :</div>
          <div class="result">
            {{
            modeldata.payment_details[0]?.cancelled_trip_payment_info
            ?.payment_mode
            }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="head">Refunded Date :</div>
          <div class="result">
            {{
            modeldata.payment_details[0]?.cancelled_trip_payment_info
            ?.payment_date | date : "dd-MM-yyyy"
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Refunded Type:</div>
          <div class="result">
            {{
            modeldata.payment_details[0]?.cancelled_trip_payment_info
            ?.payment_type
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="head">Comment:</div>
          <div class="result">
            {{
            modeldata.payment_details[0]?.cancelled_trip_payment_info?.reason
            }}
          </div>
        </div>
      </div>
    </form>
  </div>
  <p>Trip History</p>
  <mat-divider></mat-divider>
  <div class="row mb mt-4 mb-4 mr-0 ml-0">
    <div class="location-payment-2" *ngFor="let history of trip_history; let i = index">
      <img src="../../../assets/img/dots.svg" *ngIf="trip_history.length - 1 != i" />
      <img src="../../../assets/img/dot_only.svg" *ngIf="trip_history.length - 1 == i" />
      <span class="places-2">
        <span>
          <h4>{{ history.message }}:</h4>
          <h6>
            {{ history.date | date : "dd MMMM, yyyy" }}
            &nbsp;&nbsp;&nbsp;
            {{ history.date | date : "h:mm a" }}
          </h6>
        </span>
      </span>
    </div>
  </div>
</div>
<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
</div>